<template>
  <div>
    <list
      ref="list"
      unit="访客"
      row-key="Id"
      :page="page"
      :query-params="params"
      :show-checkbox="false"
      :show-query="showQuery"
      :get-data-func="api.CheckList"
      @reset-query="$emit('reset-select')"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <!-- <el-form-item label="客户名称">
          <el-select v-model="params.CustomerId" size="mini">
            <el-option v-for="item in cList" :key="item.WholesalerId" :value="item.WholesalerId" :label="item.WholesalerName"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="客户名称">
         <customer  @restaurants='setSupplier' :state='params.CustomerName'/>
        </el-form-item>
    
        <el-form-item label="商品名称">
          <el-input size="mini" clearable v-model="params.GoodsName" placeholder="请输入商品名称" />
        </el-form-item>
        <el-form-item label="商品编号">
          <el-input size="mini" clearable v-model="params.GoodsCode" placeholder="请输入商品编号" />
        </el-form-item>
         <el-form-item label="选择月份">
              <el-date-picker
                v-model="params.OrderDate"
                size="mini"
                type="month"
                 style="width: 180px"
                placeholder="选择月">
              </el-date-picker>
        </el-form-item>
   
        <!-- <el-form-item label="订单来源">
          <el-select size="mini" v-model="params.Source" placeholder="请选择" clearable>
            <el-option label="线上" :value="1"></el-option>
            <el-option label="线下" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="交货方式">
          <el-select size="mini" v-model="params.FreightMode" placeholder="请选择" clearable>
            <el-option label="异地配送" :value="1"></el-option>
            <el-option label="本地配送" :value="2"></el-option>
            <el-option label="自提" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="单据状态">
          <el-select size="mini" v-model="params.Status" placeholder="请选择" clearable>
            <el-option label="草稿" :value="1"></el-option>
            <el-option label="未生效" :value="2"></el-option>
            <el-option label="已生效" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="出库状态">
          <el-select size="mini" v-model="params.OutStatus" placeholder="请选择" clearable>
            <el-option label="未出库" :value="1"></el-option>
            <el-option label="部分出库" :value="2"></el-option>
            <el-option label="已出库" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="物流状态">
          <el-input size="mini" clearable v-model="params.GoodsName" placeholder="请输入物流状态" />
        </el-form-item>
        <el-form-item label="开票状态">
          <el-select size="mini" v-model="params.InvoiceStatus" placeholder="请选择" clearable>
            <el-option label="未完成" :value="1"></el-option>
            <el-option label="已完成" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="收款状态">
          <el-select size="mini" v-model="params.ReceiptStatus" placeholder="请选择" clearable>
            <el-option label="未收款" :value="1"></el-option>
            <el-option label="部分收款" :value="2"></el-option>
            <el-option label="已收款" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="物流单号">
          <el-input size="mini" clearable v-model="params.FreightNo" placeholder="请输入物流单号" />
        </el-form-item>
        <el-form-item label="单据日期">
          <el-date-picker
            size="mini"
            v-model.trim="params.DocDateStart"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            style="width: 180px"
          ></el-date-picker>
          <span style="margin:0 10px;">-</span>
          <el-date-picker
            size="mini"
            v-model.trim="params.DocDateEnd"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            style="width: 180px"
          ></el-date-picker>
        </el-form-item> -->
        <el-form-item label="是否明细">
          <el-select size="mini" v-model="params.IsDetail" placeholder="请选择" @change="search">
            <el-option label="是" :value="true"></el-option>
            <el-option label="否" :value="false"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="OrderNo" label="单据编号" min-width="110px"  v-if="params.IsDetail"/>
        <el-table-column prop="OrderDate" label="单据日期" min-width="110px" />
        <el-table-column prop="CustomerName" label="客户名称" min-width="110px" />
        <el-table-column prop="GoodsName" label="商品名称" />
        <el-table-column prop="GoodsCode" label="商品编号" />
        <el-table-column prop="Amount" label="销货金额" />
        <!-- <el-table-column prop="ClerkName" label="业务员" />
        <el-table-column prop="Status" label="单据状态">
          <template slot-scope="{row}">
            <span v-if="row.Status==0">草稿</span>
            <span v-else-if="row.Status==1">未生效</span>
            <span v-else>已生效</span>
          </template>
        </el-table-column>
        <el-table-column prop="OutStatus" label="出库状态">
          <template slot-scope="{row}">
            <span v-if="row.OutStatus==0">未出库</span>
            <span v-else-if="row.Status==1">部分出库</span>
            <span v-else>已出库</span>
          </template>
        </el-table-column>
        <el-table-column prop="ReceiptStatus" label="收款状态">
          <template slot-scope="{row}">
            <span v-if="row.ReceiptStatus==0">未收款</span>
            <span v-else-if="row.ReceiptStatus==1">部分收款</span>
            <span v-else>已收款</span>
          </template>
        </el-table-column>
        <el-table-column prop="InvoiceStatus" label="开票状态">
          <template slot-scope="{row}">
            <span v-if="row.ReceiptStatus==0">未完成</span>
            <span v-else>已完成</span>
          </template>
        </el-table-column> -->
        <slot name="column"></slot>
      </template>
    </list>
    <unit-dialog
      ref="unitDialog"
      in-dialog
      selectable
      @select="setUnit"
      title="客户列表"
      :typeList="[1,2]"
    />
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import unitDialog from "@/components/basicinfo/basic/logistics/listDialog";
import customer from "@/components/common/customer/customer";
export default {
  mixins: [listMixin],
  components: { list,unitDialog,customer },
  beforeMount() {
    this.cApi.list({ pageSize: 100, pageIndex: 1 }).then(res => {
      this.cList = res.Data
      sessionStorage.setItem("cList",JSON.stringify(res.Data))
    })
  },
  data() {
    return {
      // api: require("@/api/mall/orderGoods").default,
      api: require("@/api/sale/saDoc").default,
      cApi: require("@/api/ba/tradeUnit").default,
      cList: [],
      params: {
        CustomerName:"",
        GoodsName:"",
        GoodsCode:"",
        IsDetail: true,
        OrderDate:this.$dayjs().endOf("month").format("YYYY-MM")
      },
    };
  },
  methods: {
    setSupplier(data) {
      
      this.params.CustomerId = data.Id;
      this.params.CustomerName = data.Name;
    },
    setUnit(e) {
      
      this.params.CustomerId = e.Id;
      this.params.CustomerName = e.Name;
    },
    addUnit(e) {
      this.$refs.unitDialog.open().then((that) => {
        that.getData({});
      });
    },
    search(){
      this.$refs.list.query()
    }
  },
};
</script>